import { Calculator } from "@phosphor-icons/react";
import clsx from "clsx";
import { format } from "date-fns";
import { DataSourceCalculation } from "../../api/models/DataSource";
import { getInitialsFromDisplayName } from "../../utils/getInitialsFromDisplayNames";
import Avatar from "../Avatar";
import Typography from "../Typography";
import EmissionsFactorTimelineSpacer from "./EmissionsFactorTimelineSpacer";

type EmissionsFactorTimelineItemProps = {
    isInitialTimelineItem?: boolean;
    isLastTimelineItem?: boolean;
} & DataSourceCalculation;

const EmissionsFactorTimelineItem = ({
    createdByDisplayName,
    emissionsFactor,
    activeFrom,
    createdAt,
    isInitialTimelineItem,
    isLastTimelineItem,
}: EmissionsFactorTimelineItemProps) => {
    return (
        <>
            <div className="w-full flex gap-12">
                <div className="hidden sm:flex flex-col items-center ml-4">
                    <div
                        className={clsx(
                            "flex-1 w-px",
                            isInitialTimelineItem
                                ? "bg-trasparent"
                                : "bg-surface-dark"
                        )}
                    />
                    <div className="flex-none w-8 h-8 rounded-full flex items-center justify-center border border-surface-dark">
                        <Calculator width={20} height={20} weight="light" />
                    </div>
                    <div
                        className={clsx(
                            "flex-1 w-px",
                            isLastTimelineItem
                                ? "bg-trasparent"
                                : "bg-surface-dark"
                        )}
                    />
                </div>
                <div className="w-full max-w-full sm:w-auto bg-surface-light-1 rounded-lg p-5 flex items-center gap-6 flex-1">
                    <div className="flex-none">
                        <Avatar
                            variant="teal"
                            initials={getInitialsFromDisplayName(
                                createdByDisplayName
                            )}
                        />
                    </div>
                    <div className="flex-1 overflow-hidden">
                        <Typography
                            variant="title-large"
                            component="h3"
                            className="mb-2 text-deep-ocean-20"
                        >
                            Emissions factor set to {emissionsFactor}
                        </Typography>
                        <Typography variant="body-large" component="p">
                            <b>Submitted by:</b> {createdByDisplayName}
                        </Typography>
                        <Typography variant="body-large" component="p">
                            <b>Applicable from date:</b>{" "}
                            {format(new Date(activeFrom), "dd/MM/yyyy")}
                        </Typography>
                        <Typography
                            variant="label-large"
                            component="p"
                            className="text-deep-ocean-20"
                        >
                            {format(
                                new Date(createdAt),
                                "dd/MM/yyyy - hh:mm a"
                            ).replace("-", "at")}
                        </Typography>
                    </div>
                </div>
            </div>
            {!isLastTimelineItem && <EmissionsFactorTimelineSpacer />}
        </>
    );
};

export default EmissionsFactorTimelineItem;
